module.exports = __webpack_public_path__ + "img/画板 58.123825eb.svg";